import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ServiceResponse } from '../../shared/models';
import { mapResponse } from '../../shared/operators/map-response';
import { CreateChatEntityData } from '../models';

interface CacheEntry {
  data: CreateChatEntityData[];
  timestamp: number;
}

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  private searchCache = new Map<string, CacheEntry>();
  private readonly CACHE_DURATION_MS = 20 * 60 * 1000; // 20 minutes

  constructor(private http: HttpClient) {}

  searchDirectMessageUsers(query: string): Observable<CreateChatEntityData[]> {
    const normalizedQuery = query.toLowerCase().trim();
    
    // Check cache first
    const cached = this.searchCache.get(normalizedQuery);
    if (cached && Date.now() - cached.timestamp < this.CACHE_DURATION_MS) {
      return of(cached.data); // Return cached data
    }

    // Make API call and cache result
    return this.http
      .get<ServiceResponse<CreateChatEntityData[]>>(`${environment.apiUrl}/api/chat/users?query=${query}`)
      .pipe(
        mapResponse(),
        tap((data) => {
          this.searchCache.set(normalizedQuery, {
            data,
            timestamp: Date.now(),
          });
          
          // Clean up old cache entries (keep max 50 entries)
          if (this.searchCache.size > 50) {
            const firstKey = this.searchCache.keys().next().value;
            this.searchCache.delete(firstKey);
          }
        })
      );
  }
  getUserChatNotificationPreferences(userId: string): Observable<boolean> {
    return this.http
      .get<ServiceResponse<boolean>>(`${environment.apiUrl}/api/chat/users/notification-preferences?userId=${userId}`)
      .pipe(mapResponse());
  }
}
